import React from "react";
import Home from "./pages/Home";
import PrismicPage from "./pages/PrismicPage";

import NotFound from "./pages/NotFound";
import { Switch, Route, Redirect } from "react-router-dom";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/home-page" render={() => <Redirect to="/" />} />
      <Route path="/404" component={NotFound} />
      <Route path="/:id" component={PrismicPage} />
    </Switch>
  );
}
